import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import { RouterEffects } from '@core/router/store/router.effects';
import { CoreEffects } from '@core/state/core.effects';

export interface AppGlobalState {
  router: RouterReducerState;
}

export const StoreReducers: ActionReducerMap<AppGlobalState> = {
  router: routerReducer
};

export const StoreEffects = [CoreEffects, RouterEffects];
